import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionDetails, AccordionSummary, Typography, FormGroup, FormControlLabel, Switch, Button, TextField, ToggleButtonGroup, ToggleButton, MenuItem, Select, IconButton, InputAdornment } from '@mui/material';
import { getUtility, Icon, CONSTANTS, toast } from '@livable/saas-react-components';
import { ALLOCATION_METHOD, BILL_FREQUENCY_NAME, UTILITY_CONFIGURATION_TYPES, VACANT_UNIT_USAGE } from 'src/constants/utilities';
import BillFrequencyModal from '../BillFrequencyModal';
import AllocationMethodModal from '../AllocationMethodModal';
import VacantUnitBills from '../VacantUnitBills';
import CADModal from '../CADModal';
import ListItem from './listItem';
import useStyles from './styles';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { isValueNumber } from 'src/utils/typeValidators';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import GLModal from '../GLModal';
import { AddNewRateModal } from 'src/pages/NewBillingModule/OldUtilityConfigurationModal/modalContent/AddNewRateModal';
import { MapColumnsModal, MapColumnsViewModal, MapColumnsEditModal, COLUMN_FIELD_MAP } from 'src/pages/NewBillingModule/OldUtilityConfigurationModal/modalContent/MapColumnsModal';
import { ProvideUnitMeterIDsModal } from 'src/pages/NewBillingModule/OldUtilityConfigurationModal/modalContent/ProvideUnitMeterIDsModal';
export const UtilityAccordion = observer(_ref => {
  let utility = _ref.utility,
    handleConfigChange = _ref.handleConfigChange,
    isEdit = _ref.isEdit,
    isDetailsPage = _ref.isDetailsPage,
    isNewUtility = _ref.isNewUtility,
    propertyId = _ref.propertyId,
    isCustomProvider = _ref.isCustomProvider,
    _ref$customMode = _ref.customMode,
    customMode = _ref$customMode === void 0 ? false : _ref$customMode,
    _ref$enableRemove = _ref.enableRemove,
    enableRemove = _ref$enableRemove === void 0 ? false : _ref$enableRemove,
    _ref$hideNotEnabled = _ref.hideNotEnabled,
    hideNotEnabled = _ref$hideNotEnabled === void 0 ? true : _ref$hideNotEnabled,
    _ref$disableToggler = _ref.disableToggler,
    disableToggler = _ref$disableToggler === void 0 ? false : _ref$disableToggler,
    _ref$utilityIsEnabled = _ref.utilityIsEnabledByDefault,
    utilityIsEnabledByDefault = _ref$utilityIsEnabled === void 0 ? false : _ref$utilityIsEnabled,
    _ref$accordionIsClose = _ref.accordionIsClosedByDefault,
    accordionIsClosedByDefault = _ref$accordionIsClose === void 0 ? true : _ref$accordionIsClose,
    _ref$triggerSaving = _ref.triggerSaving,
    triggerSaving = _ref$triggerSaving === void 0 ? false : _ref$triggerSaving,
    setBuildingSquareFootageLocalExternal = _ref.setBuildingSquareFootageLocalExternal,
    propertySqFootageExternal = _ref.propertySqFootageExternal;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _React$useReducer = React.useReducer(o => !o),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    forceUpdate = _React$useReducer2[1];
  const accordionIsDisabled = false;
  const _useState = useState(!!utility.isEnabled && !utility.isFetched),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useState3 = useState(!(utility !== null && utility !== void 0 && utility.isFetched) || false),
    _useState4 = _slicedToArray(_useState3, 2),
    isNameEditing = _useState4[0],
    setIsNameEditing = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    initUtilityName = _useState6[0],
    setInitUtilityName = _useState6[1];
  const _useState7 = useState(utility.isEnabled || utilityIsEnabledByDefault || false),
    _useState8 = _slicedToArray(_useState7, 2),
    utilityEnabled = _useState8[0],
    setUtilityEnabled = _useState8[1];
  const _useState9 = useState(utility.billFrequencyType),
    _useState0 = _slicedToArray(_useState9, 2),
    utilityBillFrequency = _useState0[0],
    setUtilityBillFrequency = _useState0[1];
  const _useState1 = useState(utility.allocationMethod),
    _useState10 = _slicedToArray(_useState1, 2),
    utilityAllocationMethod = _useState10[0],
    setUtilityAllocationMethod = _useState10[1];

  // const [vacantUnitBills, setVacantUnitBills] = useState(utility.vacantUnitAllocation);
  // const [vacantUnitUsage, setVacantUnitUsage] = useState(utility.vacantUnitUsage);

  const _useState11 = useState(utility.utilityCAD || 5),
    _useState12 = _slicedToArray(_useState11, 2),
    utilityCad = _useState12[0],
    setUtilityCad = _useState12[1];
  const _useState13 = useState(propertySqFootageExternal || store.addNewProperty.utilitiesSetupV2.getPropertySqFootage),
    _useState14 = _slicedToArray(_useState13, 2),
    buildingSquareFootageLocal = _useState14[0],
    setBuildingSquareFootageLocal = _useState14[1];
  const _useState15 = useState(utility.goodWillDeduction),
    _useState16 = _slicedToArray(_useState15, 2),
    goodWillDeduction = _useState16[0],
    setGoodWillDeduction = _useState16[1];
  const isSubmeterEnabled = store.account.featureFlagsStore.getEnableSubmeterBilling;

  // For a brand-new utility ("Add utility" on details page) the Meter IDs / Map columns UI
  // must be hidden and only the disclaimer shown — same as the property creation flow.
  const showSubmeterFullUI = !isNewUtility && (isEdit || isDetailsPage);
  const _useState17 = useState(() => utility.allocationMethod === ALLOCATION_METHOD.BySubmeter ? 'SubMeter' : 'RUBS'),
    _useState18 = _slicedToArray(_useState17, 2),
    billingMethod = _useState18[0],
    setBillingMethod = _useState18[1];
  const _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    unitOfMeasure = _useState20[0],
    setUnitOfMeasure = _useState20[1];
  const _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    consumptionTiers = _useState22[0],
    setConsumptionTiers = _useState22[1];
  const _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    rates = _useState24[0],
    setRates = _useState24[1];
  const _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    mappings = _useState26[0],
    setMappings = _useState26[1];
  const _useState27 = useState(0),
    _useState28 = _slicedToArray(_useState27, 2),
    meterIdsProvided = _useState28[0],
    setMeterIdsProvided = _useState28[1];
  useEffect(() => {
    setUtilityBillFrequency(utility.billFrequencyType);
  }, [utility.billFrequencyType]);
  useEffect(() => {
    setUtilityAllocationMethod(utility.allocationMethod);
    setBillingMethod(utility.allocationMethod === ALLOCATION_METHOD.BySubmeter ? 'SubMeter' : 'RUBS');
  }, [utility.allocationMethod]);
  useEffect(() => {
    setUtilityCad(utility.utilityCAD || 5);
  }, [utility.utilityCAD]);
  useEffect(() => {
    setGoodWillDeduction(utility.goodWillDeduction);
  }, [utility.goodWillDeduction]);
  const handleSetUtilityAllocationMethod = value => {
    if (value) {
      setUtilityAllocationMethod(value);
    }
  };
  if (handleConfigChange === undefined) {
    handleConfigChange = data => {
      if (!isCustomProvider) {
        store.addNewProperty.utilitiesSetupV2.updateUtilityConfig(data);
        Promise.all(data.map(_ref2 => {
          let utilityData = _ref2.utility,
            values = _ref2.values;
          let isNeededToUpdate = false;
          let isUtilityToDeleteFromProperty = false;
          let isAllocationMethodBySquareFootage = false;
          values.forEach(_ref3 => {
            let key = _ref3.key,
              value = _ref3.value;
            if (key === 'allocationMethod' && (value === ALLOCATION_METHOD.BySquareFootage || value === ALLOCATION_METHOD.By50Occupancy50SquareFootage)) isAllocationMethodBySquareFootage = true;
            if (utilityData[key] !== value) {
              utilityData[key] = value;
              isNeededToUpdate = true;
            }
            if (key === 'isEnabled' && value === false && utilityData.isFetched) {
              isUtilityToDeleteFromProperty = true;
            }
            if (!utilityData.isFetched) {
              isNeededToUpdate = false;
            }
          });
          let updateSquareFootagePromise;
          if (isAllocationMethodBySquareFootage && (Number(buildingSquareFootageLocal) >= 0 || Number(store.addNewProperty.utilitiesSetupV2.getPropertySqFootage) >= 0)) {
            updateSquareFootagePromise = new Promise(async () => {
              const buildingsData = await store.buildings.getBuildingAsync.run({
                propertyId
              });
              const currentBuildingId = singleElementOfArray(buildingsData.response).id;
              await store.properties.updatePropertyAsync.run({
                propertyId,
                buildings: [{
                  buildingId: currentBuildingId,
                  buildingSquare: Number(buildingSquareFootageLocal || store.addNewProperty.utilitiesSetupV2.getPropertySqFootage)
                }]
              });
            });
          }
          if (!utilityData.id || utilityData.id === utilityData.utilityId) return undefined;
          const utilityToSave = {
            goodWillDeduction: utilityData.goodWillDeduction,
            id: utilityData.id,
            propertyUtilityId: utilityData.id,
            propertyId: propertyId,
            utilityProviderId: utilityData.utilityProviderId,
            utilityId: utilityData.utilityId,
            billFrequencyType: utilityData.billFrequencyType,
            allocationMethod: utilityData.allocationMethod,
            buildingIds: utilityData.buildingIds,
            utilityCap: utilityData.utilityCap,
            customCommonAreaDeduction: utilityData.utilityCAD,
            vacantUnitAllocation: utilityData.vacantUnitAllocation,
            vacantUnitUsage: utilityData.vacantUnitUsage,
            vacantUnitUsageLimit: utilityData.vacantUnitUsageLimit / 100
          };
          return [!isNeededToUpdate ? undefined : isUtilityToDeleteFromProperty ? store.propertyUtility.deleteNewPropertyUtilityConfigAsync.run({
            propertyId: propertyId,
            utilityId: utilityData.id,
            propertyUtilityId: utilityData.id
          }).then(_ref4 => {
            let response = _ref4.response,
              isSuccessful = _ref4.isSuccessful;
            store.addNewProperty.utilitiesSetupV2.removeUtilityToDelete(_objectSpread({}, utilityData));
            store.addNewProperty.utilitiesSetupV2.updateUtilityConfig(data.map(i => {
              return _objectSpread(_objectSpread({}, i), {}, {
                values: [{
                  key: 'isFetched',
                  value: false
                }]
              });
            }));
          }) : store.propertyUtility.updateNewPropertyUtilityConfigAsync.run(utilityToSave), updateSquareFootagePromise];
        }).flat().filter(i => !!i)).then(res => {
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          res.length && toast('success', {
            body: ['Configuration updated']
          });
        });
      } else {
        store.addNewProperty.utilitiesSetupV2.updateNewUtilityConfiguration(data, isCustomProvider ? isEdit ? UTILITY_CONFIGURATION_TYPES.EditCustomUtilityProviderConfigurator : UTILITY_CONFIGURATION_TYPES.CustomUtilityProviderConfigurator : UTILITY_CONFIGURATION_TYPES.UtilityConfigurator);
      }
    };
  }
  const genericSaveAndCloseHandler = data => handleConfigChange(data);
  const vacantUnitBillsSaveAndCloseHandler = id => handleConfigChange([{
    values: [{
      key: 'vacantUnitAllocation',
      value: 'AllocateToOwner'
    }, {
      key: 'vacantUnitUsage',
      value: store.addNewProperty.vacantUnitUsage.get(id)
    }, {
      key: 'vacantUnitUsageLimit',
      value: store.addNewProperty.vacantUnitUsageLimit.get(id)
    }],
    utility
  }]);
  const updateParentBuildingSquareFootageLocal = value => {
    setBuildingSquareFootageLocal(value);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    setBuildingSquareFootageLocalExternal ? setBuildingSquareFootageLocalExternal(value) : store.addNewProperty.utilitiesSetupV2.changeSqFootage(value);
  };

  /**
   * isUtilityCadDefault
   * @param {null | boolean} utilityDefaultCad
   * @param {number | string | null} utilityCadValue
   * @returns {boolean}
   */
  const isUtilityCadDefault = (utilityDefaultCad, utilityCadValue) => {
    const systemDefaultCad = 5;
    if (utilityDefaultCad === null) {
      return utilityCadValue === systemDefaultCad;
    }
    // Means default CAD is === 0
    if (utilityDefaultCad !== null && typeof utilityDefaultCad === 'boolean' && utilityDefaultCad === false) {
      return utilityCadValue === 0;
    }
    if (utilityDefaultCad !== null && typeof utilityDefaultCad === 'boolean' && utilityDefaultCad === true) {
      return utilityCadValue === 5;
    }
    return false;
  };
  const updateCustomUtilityName = utilityObject => {
    if (isNameEditing) setIsOpen(true);
    setIsNameEditing(!isNameEditing);
    if (initUtilityName !== utilityObject.name && utilityObject.isFetched) store.utilityProviders.updateCustomUtilityTypeAsync.run(utilityObject).then(res => {
      if (res !== null && res !== void 0 && res.isSuccessful) {
        toast('success', {
          body: ['Utility Name updated']
        });
        // TODO: update name in selected utilities if exist
      }
    });
  };
  const triggerUtilityNameSaving = () => {
    if (customMode && isNameEditing && triggerSaving) {
      setIsNameEditing(!isNameEditing);
      updateCustomUtilityName(utility);
    }
  };
  useEffect(() => {
    // setIsOpen(utilityEnabled);
    // if (accordionIsClosedByDefault) setIsOpen(false);
    if (utilityIsEnabledByDefault) setIsOpen(false);
    // if (!utilityEnabled) setIsOpen(false);
  }, [utilityEnabled, utilityIsEnabledByDefault, accordionIsClosedByDefault]);
  useEffect(() => {
    triggerUtilityNameSaving();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerSaving]);
  const handleUtilityEnabled = () => {
    setUtilityEnabled(!utilityEnabled);
    setIsOpen(!utilityEnabled || !utility.isEnabled && !utility.isFetched);
    handleConfigChange([{
      values: [{
        key: 'isEnabled',
        value: !utilityEnabled
      }],
      utility
    }]);
  };
  const handleAddTier = () => setConsumptionTiers(prev => [...prev, {
    id: Date.now(),
    value: ''
  }]);
  const handleRemoveTier = id => setConsumptionTiers(prev => prev.filter(tier => tier.id !== id));
  const handleAddRate = rateData => setRates(prev => [...prev, _objectSpread({
    id: Date.now()
  }, rateData)]);
  const handleRemoveRate = id => setRates(prev => prev.filter(r => r.id !== id));
  const handleAddMapping = mappingData => setMappings(prev => [...prev, mappingData]);
  const handleUpdateMapping = updatedMapping => setMappings(prev => prev.map(m => m.id === updatedMapping.id ? updatedMapping : m));
  const handleRemoveMapping = async id => {
    const resp = await store.allocations.deleteSubmeterBillingCsvMapAsync.run({
      id
    });
    if (!(resp !== null && resp !== void 0 && resp.isSuccessful)) return;
    setMappings(prev => prev.filter(m => m.id !== id));
  };
  useEffect(() => {
    if (!isSubmeterEnabled) return;
    if (!isEdit) return;
    if (!utility.id || utility.id === 'NEW_UTILITY_TEMPLATE') return;
    store.allocations.getSubmeterBillingCsvMapsAsync.run({
      propertyUtilityId: utility.id
    }).then(resp => {
      var _store$homeDashboardS, _store$homeDashboardS2;
      if (!(resp !== null && resp !== void 0 && resp.isSuccessful) || !Array.isArray(resp.response)) return;
      const units = (_store$homeDashboardS = (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.selectedPropertyDetails()) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.details) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.unitSetup) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.units) !== null && _store$homeDashboardS !== void 0 ? _store$homeDashboardS : [];
      const unitIdToName = Object.fromEntries(units.filter(u => u.id && u.name).map(u => [u.id, u.name]));
      const normalized = resp.response.map(m => {
        var _m$unitMappings;
        return _objectSpread(_objectSpread({}, m), {}, {
          columnMappings: COLUMN_FIELD_MAP.reduce((acc, _ref5) => {
            let field = _ref5.field;
            return _objectSpread(_objectSpread({}, acc), {}, {
              [field]: m[field] || ''
            });
          }, {}),
          unitMappings: ((_m$unitMappings = m.unitMappings) !== null && _m$unitMappings !== void 0 ? _m$unitMappings : []).reduce((acc, _ref6) => {
            let unitId = _ref6.unitId,
              identifiers = _ref6.identifiers;
            return _objectSpread(_objectSpread({}, acc), {}, {
              [unitIdToName[unitId] || unitId]: (identifiers === null || identifiers === void 0 ? void 0 : identifiers[0]) || ''
            });
          }, {})
        });
      });
      setMappings(normalized);
    });
    store.allocations.getSubmeterBillingUnitMeterMapsAsync.run({
      propertyUtilityId: utility.id
    }).then(resp => {
      if (resp !== null && resp !== void 0 && resp.isSuccessful && Array.isArray(resp.response)) {
        const uniqueUnitIds = new Set(resp.response.map(e => e.unitId).filter(Boolean));
        setMeterIdsProvided(uniqueUnitIds.size);
      }
    });
  }, [utility.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const GetListItems = () => {
    const list = [{
      title: t('add_new_property_flow.bill_frequency'),
      id: "UtilityAccordion_bill_frequency_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_ID"),
      key: "UtilityAccordion_bill_frequency_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_Key"),
      value: BILL_FREQUENCY_NAME[utility.billFrequencyType] || BILL_FREQUENCY_NAME.Monthly,
      isActive: BILL_FREQUENCY_NAME.Monthly !== BILL_FREQUENCY_NAME[utility.billFrequencyType],
      isDefault: BILL_FREQUENCY_NAME.Monthly === BILL_FREQUENCY_NAME[utility.billFrequencyType],
      action: /*#__PURE__*/React.createElement(BillFrequencyModal, {
        utilityBillFrequancy: utilityBillFrequency,
        setUtilityBillFrequency: setUtilityBillFrequency,
        utility: utility,
        disabledTrigger: !utilityEnabled,
        onSaveAndClose: genericSaveAndCloseHandler,
        isEdit: isEdit,
        customMode: customMode
      })
    }, {
      title: t('add_new_property_flow.allocation_method'),
      id: "UtilityAccordion_handling_allocation_method_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_ID"),
      key: "UtilityAccordion_handling_allocation_method_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_Key"),
      value: isSubmeterEnabled && billingMethod === 'SubMeter' ? CONSTANTS.ALLOCATION_METHODS.BySubmeter : CONSTANTS.ALLOCATION_METHODS[utility.allocationMethod] || !!utility.defaultAllocationMethod && CONSTANTS.ALLOCATION_METHODS[utility.defaultAllocationMethod] || t('general.occupancy'),
      isDefault: isSubmeterEnabled && billingMethod === 'SubMeter' || utility.defaultAllocationMethod === null || utility.defaultAllocationMethod === utility.allocationMethod,
      isActive: !(isSubmeterEnabled && billingMethod === 'SubMeter') && utility.defaultAllocationMethod !== null && utility.defaultAllocationMethod !== utility.allocationMethod,
      isError: !(isSubmeterEnabled && billingMethod === 'SubMeter') && utilityEnabled && (ALLOCATION_METHOD.BySquareFootage === utility.allocationMethod || ALLOCATION_METHOD.By50Occupancy50SquareFootage === utility.allocationMethod) && (buildingSquareFootageLocal ? !isValueNumber(buildingSquareFootageLocal) || isValueNumber(buildingSquareFootageLocal) && Number(buildingSquareFootageLocal) === 0 : !isValueNumber(propertySqFootageExternal) || isValueNumber(propertySqFootageExternal) && Number(propertySqFootageExternal) === 0),
      action: isSubmeterEnabled && billingMethod === 'SubMeter' ? null : /*#__PURE__*/React.createElement(AllocationMethodModal, {
        setUtilityAllocationMethod: handleSetUtilityAllocationMethod,
        utility: utility,
        disabledTrigger: !utilityEnabled,
        onSaveAndClose: genericSaveAndCloseHandler,
        isEdit: isEdit,
        customMode: customMode,
        setParentBuildingSquareFootageLocal: updateParentBuildingSquareFootageLocal,
        propertySqFootage: buildingSquareFootageLocal || propertySqFootageExternal || store.addNewProperty.utilitiesSetupV2.getPropertySqFootage
      })
    }, {
      title: t('add_new_property_flow.handling_vacant_unit'),
      id: "UtilityAccordion_handling_vacant_unit_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_ID"),
      key: "UtilityAccordion_handling_vacant_unit_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_Key"),
      value: utility.vacantUnitUsage === VACANT_UNIT_USAGE.NoUsage ? t('add_new_property_flow.no_usage') : utility.vacantUnitUsage === VACANT_UNIT_USAGE.NormalUsage ? t('add_new_property_flow.full_usage') : t('add_new_property_flow.unit_usage_limited_usage'),
      isDefault: utility.defaultVacantUnitUsage === null || utility.defaultVacantUnitUsage === utility.vacantUnitUsage,
      isActive: utility.defaultVacantUnitUsage !== null && utility.defaultVacantUnitAllocation !== utility.vacantUnitAllocation,
      action: /*#__PURE__*/React.createElement(VacantUnitBills, {
        customMode: customMode,
        disabledTrigger: !utilityEnabled,
        isEdit: isEdit,
        onSaveAndClose: vacantUnitBillsSaveAndCloseHandler
        // setVacantUnitBills={setVacantUnitBills}
        // setVacantUnitUsage={setVacantUnitUsage}
        ,
        utility: utility
      })
    }, {
      title: t('add_new_property_flow.common_area_deduction'),
      id: "UtilityAccordion_common_area_deduction_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_ID"),
      key: "UtilityAccordion_common_area_deduction_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_Key"),
      isDefault: isUtilityCadDefault(utility.isDefaultCAD, utility.utilityCAD),
      isActive: !isUtilityCadDefault(utility.isDefaultCAD, utility.utilityCAD),
      value: utility.utilityCAD + '%',
      // isError: true, // NOTE: TBD if needed
      customMode: customMode,
      action: /*#__PURE__*/React.createElement(CADModal, {
        setUtilityCad: setUtilityCad,
        utility: utility,
        disabledTrigger: !utilityEnabled,
        onSaveAndClose: genericSaveAndCloseHandler,
        isEdit: isEdit,
        customMode: customMode,
        goodWillDeductionValue: goodWillDeduction
      })
    }];
    if (showSubmeterFullUI && isSubmeterEnabled && billingMethod === 'SubMeter') {
      var _store$homeDashboardS3, _store$homeDashboardS4;
      const totalUnits = ((_store$homeDashboardS3 = (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.selectedPropertyDetails()) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.details) === null || _store$homeDashboardS4 === void 0 || (_store$homeDashboardS4 = _store$homeDashboardS4.unitSetup) === null || _store$homeDashboardS4 === void 0 ? void 0 : _store$homeDashboardS4.units) !== null && _store$homeDashboardS3 !== void 0 ? _store$homeDashboardS3 : []).filter(u => u.id && u.name).length;
      const meterIdsValue = meterIdsProvided === 0 ? 'Not provided' : meterIdsProvided >= totalUnits ? 'All provided' : "Provided ".concat(meterIdsProvided, "/").concat(totalUnits);
      list.unshift({
        title: t('Meter IDs'),
        id: "UtilityAccordion_meter_ids_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_ID"),
        key: "UtilityAccordion_meter_ids_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_Key"),
        value: meterIdsValue,
        warningValue: meterIdsProvided === 0,
        isActive: true,
        action: /*#__PURE__*/React.createElement(ProvideUnitMeterIDsModal, {
          utility: utility,
          propertyUtilityId: utility.id,
          hasMeterIds: meterIdsProvided > 0,
          onHasMeterIdsChange: setMeterIdsProvided
        })
      });
    }
    list.push({
      title: t('general.goodwill_deduction'),
      id: "UtilityAccordion_good_will_deduction_id",
      key: "UtilityAccordion_good_will_deduction_key",
      value: goodWillDeduction,
      isGWD: true,
      isDefault: utility.goodWillDeduction === 5,
      utilityCAD: utility.utilityCAD,
      submitCallback: val => {
        genericSaveAndCloseHandler([{
          values: [{
            key: 'goodWillDeduction',
            value: Number(val)
          }],
          utility
        }]);
        setGoodWillDeduction(Number(val));
      },
      isActive: true,
      isEditable: true
    });
    if (store.company.companyFeatureStore.isAppfolio) {
      var _customGl, _customGl2, _customGl3;
      let customGl = undefined;
      const defaultGl = store.credentials.glAccounts.find(i => i.externalId === store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId);
      const pUtility = store.credentials.utilitiesGlSettings.find(i => i.utilityId === (utility.utilityId || utility.utilityTypeId));
      if (pUtility && pUtility !== null && pUtility !== void 0 && pUtility.glAccountExternalId) {
        customGl = store.credentials.glAccounts.find(i => i.externalId === pUtility.glAccountExternalId);
      }
      list.push({
        title: t('Resident Charges GL Account (Income)'),
        id: "UtilityAccordion_gl_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_ID"),
        key: "UtilityAccordion_gl_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_Key"),
        isDefault: !customGl || (defaultGl === null || defaultGl === void 0 ? void 0 : defaultGl.externalId) === ((_customGl = customGl) === null || _customGl === void 0 ? void 0 : _customGl.externalId),
        isActive: false,
        value: customGl && (_customGl2 = customGl) !== null && _customGl2 !== void 0 && _customGl2.name ? (_customGl3 = customGl) === null || _customGl3 === void 0 ? void 0 : _customGl3.name : defaultGl === null || defaultGl === void 0 ? void 0 : defaultGl.name,
        customMode: customMode,
        action: /*#__PURE__*/React.createElement(GLModal, {
          utility: utility,
          disabledTrigger: !utilityEnabled,
          onSaveAndClose: async data => {
            var _data$pUtility;
            await store.credentials.patchAppfolioPropertiesAsync.run({
              properties: [{
                propertyLivableId: propertyId,
                utilityGlAccounts: {
                  value: [_objectSpread({
                    propertyUtilityLivableId: data.utility.id,
                    glAccountExternalId: data.glAccountExternalId || store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId || null
                  }, store.account.featureFlagsStore.getIsGlCodesEnabled ? {
                    accountsPayableGlAccountExternalId: ((_data$pUtility = data.pUtility) === null || _data$pUtility === void 0 ? void 0 : _data$pUtility.accountsPayableGlAccountExternalId) || null
                  } : {})]
                }
              }]
            }).then(resp => {
              if (resp && resp !== null && resp !== void 0 && resp.isSuccessful) toast('success', {
                body: ['GL account updated!']
              });
            });
            forceUpdate();
          },
          isEdit: isEdit,
          customMode: customMode
        })
      });
      if (store.account.featureFlagsStore.getIsGlCodesEnabled) {
        var _customPayableGl, _customPayableGl2, _customPayableGl3;
        let customPayableGl = undefined;
        const defaultPayableGl = store.credentials.glAccounts.find(i => i.externalId === store.addNewProperty.utilitiesSetupV2.accountsPayableGlAccountExternalId);
        if (pUtility && pUtility !== null && pUtility !== void 0 && pUtility.accountsPayableGlAccountExternalId) {
          customPayableGl = store.credentials.glAccounts.find(i => i.externalId === pUtility.accountsPayableGlAccountExternalId);
        }
        list.push({
          title: t('Accounts Payable GL Account (Expense)'),
          id: "UtilityAccordion_payable_gl_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_ID"),
          key: "UtilityAccordion_payable_gl_".concat(utility.id || utility.utilityId || utility.utilityTypeId, "_Key"),
          isDefault: !customPayableGl || (defaultPayableGl === null || defaultPayableGl === void 0 ? void 0 : defaultPayableGl.externalId) === ((_customPayableGl = customPayableGl) === null || _customPayableGl === void 0 ? void 0 : _customPayableGl.externalId),
          isActive: false,
          value: customPayableGl && (_customPayableGl2 = customPayableGl) !== null && _customPayableGl2 !== void 0 && _customPayableGl2.name ? (_customPayableGl3 = customPayableGl) === null || _customPayableGl3 === void 0 ? void 0 : _customPayableGl3.name : defaultPayableGl === null || defaultPayableGl === void 0 ? void 0 : defaultPayableGl.name,
          customMode: customMode,
          action: /*#__PURE__*/React.createElement(GLModal, {
            isPayable: true,
            utility: utility,
            disabledTrigger: !utilityEnabled,
            onSaveAndClose: async data => {
              var _data$pUtility2;
              await store.credentials.patchAppfolioPropertiesAsync.run({
                properties: [{
                  propertyLivableId: propertyId,
                  utilityGlAccounts: {
                    value: [{
                      propertyUtilityLivableId: data.utility.id,
                      glAccountExternalId: ((_data$pUtility2 = data.pUtility) === null || _data$pUtility2 === void 0 ? void 0 : _data$pUtility2.glAccountExternalId) || store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId || null,
                      accountsPayableGlAccountExternalId: data.accountsPayableGlAccountExternalId
                    }]
                  }
                }]
              }).then(resp => {
                if (resp && resp !== null && resp !== void 0 && resp.isSuccessful) toast('success', {
                  body: ['GL Payable account updated!']
                });
              });
              forceUpdate();
            },
            isEdit: isEdit,
            customMode: customMode
          })
        });
      }
    }
    return list.map(item => /*#__PURE__*/React.createElement(ListItem, {
      key: !isEdit ? "List_ITEM_NEW_".concat(item.id) : "List_ITEM_".concat(item.id),
      item: item,
      isDisabled: !utilityEnabled
    }));
  };
  const getAccordionStyles = () => {
    return "".concat(classes.accordion, " ").concat(!utilityEnabled ? classes.utilityDisabled : '', " ").concat(accordionIsDisabled ? classes.accordionDisabled : '', " ").concat(hideNotEnabled && !utilityEnabled ? classes.hidden : '');
  };
  return /*#__PURE__*/React.createElement(Accordion, {
    className: getAccordionStyles(),
    expanded: !accordionIsDisabled ? isOpen : false,
    key: "key_UtilityAccordion_".concat(utility.id || utility.utilityTypeId),
    id: "id_UtilityAccordion_".concat(utility.id || utility.utilityTypeId)
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "utility-accordion",
    id: "utility-accordion-id-".concat(utility.id || utility.utilityTypeId),
    key: "utility-accordion-key-".concat(utility.id || utility.utilityTypeId),
    expandIcon: !accordionIsDisabled ? /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-line-right",
      fontSize: "large"
    }) : null,
    onClick: () => {
      setIsOpen(prevValue => !prevValue);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accorionUtilityContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.utilityWrapper
  }, !disableToggler && /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    onChange: handleUtilityEnabled,
    checked: utilityEnabled,
    disabled: accordionIsDisabled || store.propertyUtility.deleteNewPropertyUtilityConfigAsync.inProgress || store.propertyUtility.updateNewPropertyUtilityConfigAsync.inProgress,
    control: /*#__PURE__*/React.createElement(Switch, {
      onClick: e => {
        e.stopPropagation();
        e.preventDefault();
        handleUtilityEnabled();
      },
      onKeyDown: e => {
        e.stopPropagation();
        e.preventDefault();
        handleUtilityEnabled();
      },
      role: "button",
      tabIndex: 0
    })
  })), /*#__PURE__*/React.createElement("span", {
    className: classes.utilityIcon
  }, getUtility(toJS(utility).name || toJS(utility).utilityTypeName).icon({
    state: accordionIsDisabled ? 'grey' : '',
    pattern: utilityEnabled ? 'gradient' : ''
  })), !customMode && /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: accordionIsDisabled ? 'disabled' : ''
  }, getUtility(toJS(utility).name || toJS(utility).utilityTypeName).title), customMode && isNameEditing && /*#__PURE__*/React.createElement("span", {
    className: classes.listItemText,
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      updateCustomUtilityName(utility);
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    autoFocus: true,
    className: classes.customUtilityField,
    label: t('add_new_property_flow.enter_util_name'),
    variant: "outlined",
    value: utility.name,
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
    },
    onChange: event => {
      event.stopPropagation();
      event.preventDefault();
      genericSaveAndCloseHandler([{
        values: [{
          key: 'name',
          value: event.target.value
        }],
        utility
      }]);
    },
    onKeyDown: e => {
      if (e.keyCode === 13) {
        e.preventDefault();
        if (utility.name.length === 0) return;
        setIsNameEditing(!isNameEditing);
        updateCustomUtilityName(utility);
        setIsOpen(!isOpen);
      }
    },
    error: utility.name.length === 0
    // helperText={utility.name.length === 0 && 'Name is required'}
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "double-check"
  })), customMode && !isNameEditing && /*#__PURE__*/React.createElement("span", {
    className: classes.listItemText,
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      setIsNameEditing(!isNameEditing);
      setInitUtilityName(utility.name);
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    className: classes.customUtilityField,
    label: t('add_new_property_flow.utility_name'),
    variant: "outlined",
    disabled: true,
    value: utility.name || utility.title,
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "edit",
    onClick: event => {
      event.stopPropagation();
      event.preventDefault();
      setIsNameEditing(!isNameEditing);
    }
  }))), accordionIsDisabled && /*#__PURE__*/React.createElement("div", {
    className: classes.infoBlock
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "info",
    state: "info",
    fontSize: "small"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "info-dark"
  }, t('add_new_property_flow.you_already_selected_option', {
    option: 'water+sewer'
  })))), enableRemove && utilityEnabled && /*#__PURE__*/React.createElement(Button, {
    onClick: e => {
      e.stopPropagation();
      e.preventDefault();
      handleUtilityEnabled();
    },
    variant: "actionButtonPlain",
    'custom-attribute': '215-UtilityAccordion'
  }, t('general.remove'))), /*#__PURE__*/React.createElement(AccordionDetails, null, isSubmeterEnabled && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 4
    }
  }, t('Select billing method')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, t('Select whether to use RUBS or the sub-meter billing method.')), /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    exclusive: true,
    size: "small",
    value: billingMethod,
    onChange: (_, val) => {
      if (!val) return;
      setBillingMethod(val);
      handleConfigChange([{
        values: [{
          key: 'allocationMethod',
          value: val === 'SubMeter' ? ALLOCATION_METHOD.BySubmeter : ALLOCATION_METHOD.ByOccupancy
        }],
        utility
      }]);
    }
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "RUBS"
  }, "RUBS"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "SubMeter"
  }, "Sub-meter"))), false && billingMethod === 'SubMeter' && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 4
    }
  }, t('Select unit of measure')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, t('Select all of the utilities that are represented in your real bill.')), /*#__PURE__*/React.createElement(Select, {
    size: "small",
    value: unitOfMeasure,
    onChange: e => setUnitOfMeasure(e.target.value),
    displayEmpty: true,
    style: {
      minWidth: 200
    },
    renderValue: val => val ? "".concat(val === 'gal' ? 'Gallons' : val, " (").concat(val, ")") : 'Unit of measure'
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "gal"
  }, "Gallons (gal)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "hcf"
  }, "HCF (hcf)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "kgal"
  }, "Kgal (kgal)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "ccf"
  }, "CCF (ccf)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "kWh"
  }, "kWh (kWh)"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "BTU"
  }, "BTU (BTU)"))), false && billingMethod === 'SubMeter' && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 4
    }
  }, t('Define consumption tiers')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, t('If the charges varies based on the utility amount consumed define the thresholds.')), consumptionTiers.map((tier, idx) => /*#__PURE__*/React.createElement("div", {
    key: tier.id,
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      marginBottom: 8,
      padding: '8px 12px',
      border: '1px solid #e0e0e0',
      borderRadius: 4
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      minWidth: 104,
      fontWeight: 600
    }
  }, "Tier ", idx + 1, " treshold"), /*#__PURE__*/React.createElement(TextField, {
    size: "small",
    style: {
      width: 120
    },
    value: tier.value,
    onChange: e => setConsumptionTiers(prev => prev.map(item => item.id === tier.id ? _objectSpread(_objectSpread({}, item), {}, {
      value: e.target.value
    }) : item)),
    InputProps: unitOfMeasure ? {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, unitOfMeasure)
    } : undefined
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    size: "small",
    onClick: () => handleRemoveTier(tier.id),
    style: {
      minWidth: 0,
      padding: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  })))), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    size: "small",
    onClick: handleAddTier
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('Add tier')))), false && billingMethod === 'SubMeter' && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 12
    }
  }, t('Define the rates')), rates.map(rate => /*#__PURE__*/React.createElement("div", {
    key: rate.id,
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 4
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, rate.rateName), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "".concat(rate.rateIn).concat(rate.rateValue)), /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: () => handleRemoveRate(rate.id)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  })))), /*#__PURE__*/React.createElement(AddNewRateModal, {
    onSave: handleAddRate
  })), isSubmeterEnabled && billingMethod === 'SubMeter' && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      marginBottom: 4
    }
  }, t('Map columns')), !showSubmeterFullUI ? /*#__PURE__*/React.createElement("div", {
    className: classes.disclaimerBox
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600,
      marginBottom: 4
    }
  }, isNewUtility ? t('Please complete and submit your utility first') : t('Please revisit the Utility Configuration after you activate the property to finish the Unit Mapping.'))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    style: {
      marginBottom: 12
    }
  }, t("Map your CSV meter read columns to our system's field names.")), mappings.map(mapping => /*#__PURE__*/React.createElement("div", {
    key: mapping.id,
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 4
    }
  }, /*#__PURE__*/React.createElement(MapColumnsViewModal, {
    mapping: mapping
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(MapColumnsEditModal, {
    mapping: mapping,
    propertyId: propertyId,
    utilityId: utility.utilityId,
    propertyUtilityId: utility.id,
    onSave: handleUpdateMapping
  }), /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: () => handleRemoveMapping(mapping.id)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  }))))), /*#__PURE__*/React.createElement(MapColumnsModal, {
    propertyId: propertyId,
    utilityId: utility.utilityId,
    propertyUtilityId: utility.id,
    onSave: handleAddMapping
  }))), isEdit && isSubmeterEnabled && billingMethod === 'SubMeter' && utility.id && utility.id !== utility.utilityId && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    disabled: store.propertyUtility.updateSubmeterConfigAsync.inProgress,
    onClick: async () => {
      var _rates$;
      await store.propertyUtility.updateSubmeterConfigAsync.run({
        propertyUtilityId: utility.id,
        isSubmeter: true,
        submeterUomBill: unitOfMeasure,
        submeterUomMeterRead: unitOfMeasure,
        submeterCsvMapId: submeterCsvMapId || null,
        submeterRate: Number((_rates$ = rates[0]) === null || _rates$ === void 0 ? void 0 : _rates$.rateValue) || 0,
        submeterBaseCharge: 0,
        submeterRateTierEnabled: consumptionTiers.length > 0
      });
    }
  }, "Save sub-meter settings")), /*#__PURE__*/React.createElement(GetListItems, null)));
});